import {
  AnalyticsCallOptions,
  getAnalytics,
  getGoogleAnalyticsClientId,
  logEvent,
  setUserProperties,
} from "firebase/analytics";
import { app } from "../initFirebase";
import { isDev } from "../../../helpers/isDev";
import { DISBALE_IN_DEV } from "./analyticsConfig";

const analytics = getAnalytics(app);

const getAnalyticsClientId = async () => {
  const clientId = await getGoogleAnalyticsClientId(analytics);
  return clientId;
};

const logAnalytics = (
  eventName: string,
  eventParams?: {
    [key: string]: any;
  },
  options?: AnalyticsCallOptions
) => {
  if (!analytics || (isDev() && DISBALE_IN_DEV)) return;
  logEvent(analytics, eventName, eventParams, options);
};

const setFirbaseUserProperties = (
  properties: {
    [key: string]: any;
  },
  options?: AnalyticsCallOptions
) => {
  if (!analytics || (isDev() && DISBALE_IN_DEV)) return;
  setUserProperties(analytics, properties, options);
};

export {
  analytics,
  getAnalyticsClientId,
  logAnalytics,
  setFirbaseUserProperties,
};
